var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"duanwu",attrs:{"id":"duanwu"}},[_c('div',{staticClass:"con-imgs-box"},_vm._l((30),function(item,index){return _c('img',{key:index,staticClass:"con-img",attrs:{"src":_vm.getConImgUrl(item)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }